/**
 * This is designed to be used in conjuntion with selectize.js which is a part
 * of the MaterialForm n2 styles form builder. In order for this to work
 * properly, you must assign BOTH selectize-custom-initializer and
 * selectize-with-empty - the former will prevent auto-initialize of selectize
 * on your select and the latter will trigger this class to initialize.
 */

export default class SelectizeWithEmpty {
  static init() {
    const inst = new SelectizeWithEmpty();
    // Both of these CSS classes are required for this to work. See above.
    inst.selector = ".selectize-with-empty.selectize-custom-initializer";
    inst.bindSelectize();
  }

  bindSelectize() {
    $(this.selector).selectize(Object.assign({}, this.n2StylesSelectizeDefaults(), {
      allowEmptyOption: true,
    }));
  }

  n2StylesSelectizeDefaults() {
    return {
      plugins: {
        position_dropdown_within_viewport: true,
        remove_button: { label: "", className: "remove" },
      },
    };
  }
}
